import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import Loadable from 'UIComponents/decorators/Loadable';
const AsyncFeedbackLoader = Loadable({
  loader: () => // @ts-expect-error untyped module
  import(
  /* webpackChunkName: 'feedback-loader' */
  'feedback-loader')
});
const FEEDBACK_SURVEY_TYPE = 'CSAT';
const FEEDBACK_SURVEY_ID = 851;
export default function FeedbackSurveyLoader({
  isPublic = false
}) {
  useEffect(() => {
    if (isPublic && window.hsFeedback) {
      window.hsFeedback.loadSurvey(FEEDBACK_SURVEY_TYPE, FEEDBACK_SURVEY_ID);
    }
  }, [isPublic]);

  if (isPublic) {
    return null;
  }

  return /*#__PURE__*/_jsx(AsyncFeedbackLoader, {
    onClientLoad: feedbackClient => feedbackClient.loadSurvey(FEEDBACK_SURVEY_TYPE, FEEDBACK_SURVEY_ID)
  });
}